module.exports = __webpack_public_path__ + "media/yushua.2b29e260.mp3";